import { getFullName, getInitials } from "@msuite/utils/users";
import { useAppShellStore } from "../../app-shell";
import { useAuthContext } from "../../auth";
import { Avatar } from "../../avatar";
import { Menu } from "../../menu";
import { Tag } from "../../tag";
import { cn } from "../../utils";
import type { NavigationProps } from "../types";

/** Props Interface */
interface SidebarNavigationMenuProps extends Pick<NavigationProps, "menuItems"> {}

export function SidebarNavigationMenu({ menuItems }: SidebarNavigationMenuProps) {
	/** Hooks */
	const { sidebarIsCollapsed } = useAppShellStore();
	const { user } = useAuthContext();

	/** Render */
	return (
		<div className="h-stack border-t-[0.5px] border-color">
			<Menu
				items={menuItems}
				side="right"
			>
				<div
					className={cn(
						"h-stack w-full pb-2 pt-3 overflow-hidden",
						sidebarIsCollapsed ? "px-2 justify-center" : "px-4 justify-between",
					)}
				>
					{!sidebarIsCollapsed && (
						<Tag
							variant="plain"
							color="emerald"
							withPing
							className="text-xs whitespace-nowrap"
						>
							{getFullName(user)}
						</Tag>
					)}
					<div
						data-cy="navigation-avatar"
						className="flex shrink-0"
					>
						<Avatar
							size="md"
							imageUrl={user?.image}
							variant="initials"
							initials={user?.initials || getInitials(user)}
						/>
					</div>
				</div>
			</Menu>
		</div>
	);
}
